import _ from "lodash";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconChevronDown } from "@pentabd/icons";
import { InputText, Select, Text } from "@pentabd/ui";

import {
  InputDateControllerRow,
  InputTextRow,
  MultiFileRow,
} from "@components";

import { useBaseData } from "@hooks/useBaseData";

import { getConvertedGradeData } from "@helpers/baseDataConvert";

import {
  PROMOTION_PARTICULARS,
  PromotionParticularsFormDataType,
} from "@validations/HRM/employee/sevicesValidation";

import { BASE_DATA } from "@constants/base-data";
// import { getRanks } from "../../../const";
import { useLanguage } from "@hooks/useLanguage";

const { GRADES } = BASE_DATA;

export const PromotionParticularsForm = ({
  isProfileDisabled,
}: {
  isProfileDisabled: boolean;
}) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const { data: grades } = useBaseData(GRADES);

  const {
    register,
    control,
    formState: { errors },
    setValue,
  } = useFormContext<PromotionParticularsFormDataType>();

  return (
    <div className="d-flex flex-column gap-8 mt-8">
      {/* <SelectControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.RANK"
        name={PROMOTION_PARTICULARS.RANK}
        error={errors}
        register={{ ...register(PROMOTION_PARTICULARS.RANK) }}
        options={getRanks(t)}
        setValue={setValue}
        control={control}
        required
      /> */}
      <InputTextRow
        register={{ ...register(PROMOTION_PARTICULARS.POSITION) }}
        label="EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.POSITION"
        error={errors}
        disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.PROMOTION_DATE"
        control={control}
        register={{ ...register(PROMOTION_PARTICULARS.PROMOTION_DATE) }}
        errors={errors}
        name={PROMOTION_PARTICULARS.PROMOTION_DATE}
        required
        disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.GO_DATE"
        control={control}
        register={{ ...register(PROMOTION_PARTICULARS.G_O_DATE) }}
        errors={errors}
        name={PROMOTION_PARTICULARS.G_O_DATE}
        required
        disabled={isProfileDisabled}
      />
      <InputTextRow
        register={{ ...register(PROMOTION_PARTICULARS.NATURE_OF_PROMOTION) }}
        label="EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.NATURE_OF_PROMOTION"
        error={errors}
        // required
        disabled={isProfileDisabled}
      />

      <div className="row mb-8">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" size="sm" color="title">
            {t(
              "EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.GRADE.LABEL",
            )}
            <span className="text-danger">&#42;</span>
          </Text>
        </div>
        <div className="col-md-12 col-lg-7">
          <Controller
            control={control}
            name={PROMOTION_PARTICULARS.GRADE}
            render={({ field }) => {
              return (
                <Select
                  {...register(PROMOTION_PARTICULARS.GRADE)}
                  options={getConvertedGradeData(grades, language)}
                  defaultValue={field.value as number}
                  onSelectItem={(grade) => {
                    setValue(PROMOTION_PARTICULARS.GRADE, grade as number);
                    setValue(
                      PROMOTION_PARTICULARS.PAY_SCALE_FROM,
                      {
                        ..._.find(grades, (_grade) => {
                          return _grade.id === grade;
                        }),
                      }.salaryScaleFrom,
                    );
                    setValue(
                      PROMOTION_PARTICULARS.PAY_SCALE_TO,
                      {
                        ..._.find(grades, (_grade) => {
                          return _grade.id === grade;
                        }),
                      }.salaryScaleTo || 0,
                    );
                  }}
                  suffix={<IconChevronDown size="16" />}
                  placeholder={t(
                    "EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.GRADE.PLACEHOLDER",
                  )}
                  disabled={isProfileDisabled}
                />
              );
            }}
          />
          <Text color="warning" size="xs">
            {t(
              "EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.GRADE.RESTRICTION",
            )}
          </Text>
        </div>
      </div>

      <div className="row mb-8">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t(
              "EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.PAY_SCALE.LABEL",
            )}
          </Text>
        </div>

        <div className="d-flex justify-content-center gap-9 align-items-center col-md-12 col-lg-7">
          <div className="flex-fill">
            <InputText
              {...register(PROMOTION_PARTICULARS.PAY_SCALE_FROM)}
              disabled
              suffix={
                <Text size="sm" color="subtitle1">
                  {t(
                    "EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.PAY_SCALE.PLACEHOLDER",
                  )}
                </Text>
              }
            />
          </div>
          <Text weight="semibold" color="title" size="sm">
            {t(
              "EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.PAY_SCALE.TO",
            )}
          </Text>
          <div className="flex-fill">
            <InputText
              {...register(PROMOTION_PARTICULARS.PAY_SCALE_TO)}
              disabled
              suffix={
                <Text size="sm" color="subtitle1">
                  {t(
                    "EMPLOYEE.SERVICES_INFO.FORM.PROMOTION_PARTICULARS_INFO.PAY_SCALE.PLACEHOLDER",
                  )}
                </Text>
              }
            />
          </div>
        </div>
      </div>
      <MultiFileRow
        name="document"
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        fileDetails={["documentName", "date", "remarks", "memorialNo"]}
        disabled={isProfileDisabled}
      />
    </div>
  );
};
